import { autoinject } from "aurelia-dependency-injection";
import { bindable, customElement } from "aurelia-templating";

@customElement("module-button")
@autoinject
export class ModuleButton {
    @bindable name: string;
    @bindable icon: string;
    @bindable content: string;
    @bindable indicator: string;
    @bindable recommended: boolean;
    @bindable selected: boolean;
    @bindable disabledReason: string;

    // Constructor
    constructor() {}

    // On element generated manually add tooltip attribute with value disabledReason
    attached() {
        const element = document.getElementById(this.name);

        if (this.disabledReason) {
            element.setAttribute("tooltip", this.disabledReason);
        }
    }
}
